
import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';

@Component
export default class VueModal extends Vue {
    @Prop({default: 'default'}) size!: string;
    @Prop({default: false}) outsideClickClose!: boolean;
    @Prop({default: 'auto'}) height!: string;
    @Prop({default: 'auto'}) width!: string;
    @Prop({default: '0'}) top!: string;
    @Prop({default: true}) showFooter!: boolean;
    @Prop({default: true}) showHeader!: boolean;
    @Prop({default: true}) showClose!: boolean;

    close(position = '') {
        if (position == 'outside' && !this.outsideClickClose) {
            return;
        }
        this.$emit('close');
    }

    get getModalSizeClass(): string {
        let sizeClass = '';
        if (this.size == 'large') {
            sizeClass = 'modal-lg VueModalContainer__Modal--Large';
        }
        if (this.size == 'full') {
            sizeClass = 'modal-full VueModalContainer__Modal--Full'
        }
        return sizeClass;
    }
}
